// src/id.ts
import { hash } from "@lb-lib/hash";
import { customAlphabet } from "nanoid";
import { customAlphabet as customAlphabetAsync } from "nanoid/async";
var _defaultId = customAlphabet(
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  20
);
var _defaultIdAsync = customAlphabetAsync(
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  20
);
var _code = customAlphabet("0123456789", 6);
var idTime = () => (/* @__PURE__ */ new Date()).getTime().toString(36).padStart(9, "0");
var idFactory = (idPrefixes) => {
  let getPrefix = (prefix) => {
    let pf = idPrefixes[prefix];
    if (!pf)
      throw new Error(`Invalid prefix: ${prefix}`);
    if (pf.endsWith("_"))
      return pf;
    return `${pf}_`;
  };
  return {
    generateId: (prefix, length = 20) => {
      let date = idTime();
      let remainingLength = length - date.length;
      if (remainingLength < 10)
        remainingLength = 10;
      return `${getPrefix(prefix)}${date}${_defaultId(remainingLength)}`;
    },
    generateIdAsync: async (prefix, length = 20) => {
      let date = idTime();
      let remainingLength = length - date.length;
      if (remainingLength < 10)
        remainingLength = 10;
      return `${getPrefix(prefix)}${date}${await _defaultIdAsync(remainingLength)}`;
    },
    generateKey: async (prefix, length = 35) => {
      let value = `${getPrefix(prefix)}${await _defaultIdAsync(length)}`;
      let sha1 = (await hash.sha1(value)).replace(/[^a-zA-Z0-9]/g, "").substring(0, 7);
      return `${value}${sha1}`;
    },
    generateCode: (length = 6) => {
      return _code(length);
    },
    generatePlainId: (length = 20) => {
      return _defaultId(length);
    },
    generateCustomId: (prefix, length = 20) => {
      return `${prefix}_${_defaultId(length)}`;
    },
    idPrefixes: Object.keys(idPrefixes).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {})
  };
};
var generateCustomId = (prefix, length = 20) => {
  return `${prefix}${_defaultId(length)}`;
};
var generatePlainId = (length = 20) => {
  return _defaultId(length);
};
var generateId = (prefix, length = 20) => {
  let date = idTime();
  let remainingLength = length - date.length;
  if (remainingLength < 10)
    remainingLength = 10;
  return `${prefix}${date}${_defaultId(remainingLength)}`;
};
var generateCode = (length = 6) => {
  return _code(length);
};
export {
  generateCode,
  generateCustomId,
  generateId,
  generatePlainId,
  idFactory,
  idTime
};
//# sourceMappingURL=index.mjs.map